import { atom } from 'jotai';
import { ROUTES } from '../../../constants/RouteNameMapping';

/**
 * Finance-round id selected in the Deals tab's master-detail view. Set when a
 * user opens a round from the Deal Docs sidebar; the Deals tab falls back to the
 * most-recent round when null or when the id isn't in the company's rounds.
 *
 * Owned by the Deals tab (its replacement for the sidebar) so the dependency
 * points forward: the sidebar imports this, not the other way around.
 */
export const selectedDealsRoundIdAtom = atom<number | null>(null);

/**
 * The Deals-tab path for the company in the given company-profile pathname
 * (e.g. `/company-profiles/acme-1/summary` → `/company-profiles/acme-1/deals`).
 */
export const dealsTabPathFrom = (pathname: string): string =>
  `${pathname.split('/').slice(0, 3).join('/')}/${ROUTES.DEALS}`;
